module.exports = __webpack_public_path__ + "static/media/multiple-choice.525134fc.svg";